import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import { IsUserLoggedIn } from "../protectedRoutes";
import { getNotificationAPI } from "../../api/apis/notification";
import { lastVisitedPage } from "../../store/reducers/userSlice";

export const LogonRoute = ({ component: Component, key: Key, ...rest }) => {
  const dispatch = useDispatch();
  const [shouldRedirect, setShouldRedirect] = useState(null);
  const loginStatus = IsUserLoggedIn();

  useEffect(() => {
    const fetchNotification = async () => {
      if (loginStatus()) {
        const notify = await getNotificationAPI();
        if (notify?.data?.data?.data?.unread_count) {
          let count = notify?.data?.data?.data?.unread_count;
          if (count > 0) {
            dispatch(lastVisitedPage("/notification"));
            sessionStorage.setItem("isFirstVisit", "false");
            setShouldRedirect("/notification");
          } else {
            setShouldRedirect("/home");
          }
        } else {
          setShouldRedirect("/home");
        }
      }
    };

    fetchNotification();
  }, [loginStatus]);

  if (shouldRedirect) {
    return (
      <Redirect
        to={{ pathname: shouldRedirect, state: { from: rest.location } }}
      />
    );
  }

  return loginStatus() ? null : (
    <Route {...rest} render={(props) => <Component key={Key} {...props} />} />
  );
};
